import { ErrorResponse } from "@boi/backend-utils";
import { ClassRequestModel, CommonResponse, CreateQuestionBankReqModel, LatestNewQuestionModel, LatestNewQuestionsResponse, LatestQuestionBankResponse, LatestQuestionBankViewReq, MigrateReqModal, QNPIdReq, QuestionBankResponse, QuestionBankViewReq, QuestionsCountModel, SubjectClassReqModel, SubjectPivotCount } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { ChapterRepo } from "../ai-generated-qp/repo/chapter-repo";
import { ClassRepo } from "../ai-generated-qp/repo/class-repo";
import { SubjectRepo } from "../ai-generated-qp/repo/subject-repo";
import { TopicRepo } from "../ai-generated-qp/repo/topic-repo";
import { CreateQuestionAdapter } from "./dtos/create-question.adapter";
import { CollegeCodesAndSymbolsRepo } from "./repos/college-codes-symbols.repo";
import { CreateQuestionRepo } from "./repos/create-question-repo";
import { TabQuestionRepo } from "./repos/tab-question.repo";
import { Subject } from "../entities/subject";
import { LanguagesRepo } from "../ai-generated-qp/repo/languages-repo";
import { CreateQuestion } from "./entities/create-question";


@Injectable()
export class QuestionBankService {
  constructor(
    private qBankRepo: CreateQuestionRepo,
    private qBankAdapter: CreateQuestionAdapter,
    private CollegeCodesRepo: CollegeCodesAndSymbolsRepo,
    private qBankRepoLatest: TabQuestionRepo,
    private classMasterRepo: ClassRepo,
    private subjectMasterRepo: SubjectRepo,
    private chapterMasterRepo: ChapterRepo,
    private topicMasterRepo: TopicRepo,
    private languageMasterRepo: LanguagesRepo
  ) { }

  // async createQuestionBank(req: CreateQuestionBankReqModel): Promise<CommonResponse> {
  //   const entity = this.qBankAdapter.convertDtoToEntity(req);
  //   const saveData = await this.qBankRepo.save(entity);
  //   return new CommonResponse(true, 2553, 'Question Bank Created Successfully', saveData);
  // }

  async createQuestionBank(req: CreateQuestionBankReqModel): Promise<CommonResponse> {
    if (!req.questionEn?.trim() && !req.questionTe?.trim() && !req.questionUr?.trim()) {
      return new CommonResponse(false, 400, 'No question text was provided in any language.');
    }

    if (!req.question?.trim()) {
      req.question = req.questionEn?.trim() || req.questionTe?.trim() || req.questionUr?.trim() || '';
    }

    const languages = [
      { langId: 2, question: req.questionEn?.trim() || '', questionEn: req.questionEn?.trim() || '', questionTe: '', questionUr: '' },
      { langId: 1, question: req.questionTe?.trim() || '', questionEn: '', questionTe: req.questionTe?.trim() || '', questionUr: '' },
      { langId: 3, question: req.questionUr?.trim() || '', questionEn: '', questionTe: '', questionUr: req.questionUr?.trim() || '' }
    ];

    const className = (await this.classMasterRepo.findOne({ where: { id: req.classId } }))?.class || '';
    const subjectName = (await this.subjectMasterRepo.findOne({ where: { id: req.subject } }))?.subject || '';
    const chapterName = (await this.chapterMasterRepo.findOne({ where: { id: req.chapter } }))?.chapter || '';
    const topicName = (await this.topicMasterRepo.findOne({ where: { id: req.topic } }))?.topic || 'Others';

    const savedEntities = [];
    const lastQ = await this.qBankRepo.findOne({
      where: { class: req.classId, subject: req.subject },
      order: { qno: 'DESC' },
    });
    const newQno = lastQ ? lastQ.qno + 1 : 0;
    const originalChapter = await this.chapterMasterRepo.findOne({
      where: { id: req.chapter }
    });
    for (const lang of languages) {
      // const subjectId = (await this.subjectMasterRepo.findOne({ where: { subject: subjectName } }))?.id;
      const subjectId = (await this.subjectMasterRepo.findOne({ where: { subject: subjectName, class: req.classId, language: lang.langId } }))?.id;
      const chapterId = (await this.chapterMasterRepo.findOne({ where: { chapterParentId: originalChapter.chapterParentId, subject: subjectId } }))?.id || 0;

      if (lang.question) {
        const dtoCopy: CreateQuestionBankReqModel = {
          ...req,
          language: lang.langId,
          question: lang.question,
          questionEn: lang.questionEn,
          questionTe: lang.questionTe,
          questionUr: lang.questionUr,
          subject: subjectId,
          chapter: chapterId,
          qno: newQno
        };

        let existing = await this.qBankRepo.findOne({
          where: {
            class: req.classId,
            subject: subjectId,
            chapter: chapterId,
            topic: req.topic,
            qno: newQno,
            language: lang.langId
          }
        });
        // console.log(existing, "existing-----");

        if (existing) {
          this.qBankRepo.merge(existing, this.qBankAdapter.convertDtoToEntity(dtoCopy));
          savedEntities.push(await this.qBankRepo.save(existing));
        } else {
          const entity = this.qBankAdapter.convertDtoToEntity(dtoCopy);
          savedEntities.push(await this.qBankRepo.save(entity));
        }
      }
    }


    // await this.qBankRepoLatest.saveOrUpdateQuestion({
    //   ...req,
    //   qno: newQno,
    //   classId: className,
    //   subject: subjectName,
    //   chapter: chapterName,
    //   topic: topicName,
    //   questionEn: req.questionEn?.trim() || '',
    //   questionTe: req.questionTe?.trim() || '',
    //   questionUr: req.questionUr?.trim() || ''
    // } as any);

    return new CommonResponse(true, 2553, 'Question Created Successfully', savedEntities);
  }
  // async updateQuestionBank(req: any): Promise<CommonResponse> {
  //   console.log(req, "r-----------");
  //   if (req.question_en_id) {
  //     await this.qBankRepo.update({ id: req.question_en_id }, { question: encodeURIComponent(req.questionEn) })
  //   }
  //   if (req.question_te_id) {
  //     await this.qBankRepo.update({ id: req.question_te_id }, { question: encodeURIComponent(req.questionTe) })
  //   }
  //   if (req.question_ur_id) {
  //     await this.qBankRepo.update({ id: req.question_ur_id }, { question: encodeURIComponent(req.questionUr) })
  //   }
  //   return new CommonResponse(true, 2554, "Question Updated Successfully");
  // }


  async updateQuestionBank(req: any): Promise<CommonResponse> {
    console.log(req, "r-----------");

    const savedEntities = [];

    const originalChapter = await this.chapterMasterRepo.findOne({
      where: { id: req.chapter }
    });
    console.log(originalChapter, "originalChapter---");

    const parentId = originalChapter?.chapterParentId

    // Collect language payloads
    const languages = [
      { id: req.question_en_id, langId: 2, question: req.questionEn?.trim() || '' },
      { id: req.question_te_id, langId: 1, question: req.questionTe?.trim() || '' },
      { id: req.question_ur_id, langId: 3, question: req.questionUr?.trim() || '' }
    ];

    for (const lang of languages) {
      if (!lang.question) continue; // skip if no question text

      if (lang.id) {
        // ✅ Update existing record
        await this.qBankRepo.update(
          { id: lang.id },
          {
            question: encodeURIComponent(lang.question),
            marks: req.marks,
            qtype: req.qtype,
            complexity: req.complexity
          }
        );
      } else {
        // ✅ Create new record if missing
        const subjectId = (await this.subjectMasterRepo.findOne({
          where: { subject: req.subject, class: req.classId, language: lang.langId }
        }))?.id;
        console.log(subjectId, "subid---");


        const chapterId = (await this.chapterMasterRepo.findOne({
          where: { chapterParentId: parentId, subject: subjectId }
        }))?.id || 0;
        console.log(chapterId, "chapid---");

        const entity = this.qBankAdapter.convertDtoToEntity({
          ...req,
          subject: subjectId,
          chapter: chapterId,
          language: lang.langId,
          question: lang.question
        });
        savedEntities.push(await this.qBankRepo.save(entity));
      }
    }

    return new CommonResponse(true, 2554, "Question Updated Successfully", savedEntities);
  }


  //   async updateQuestionBank(req: any): Promise<CommonResponse> {
  //   // console.log(req, "r-----------");

  //   const sharedFields = {
  //     marks: req.marks,
  //   };

  //   const languageUpdates = [
  //     { id: req.question_en_id, question: req.questionEn },
  //     { id: req.question_te_id, question: req.questionTe },
  //     { id: req.question_ur_id, question: req.questionUr },
  //   ];

  //   for (const entry of languageUpdates) {
  //     if (entry.id) {
  //       await this.qBankRepo.update(
  //         { id: entry.id },
  //         {
  //           ...sharedFields,
  //           question: encodeURIComponent(entry.question),
  //         }
  //       );
  //     }
  //   }

  //   return new CommonResponse(true, 2554, "Question Updated Successfully");
  // }



  async getQuestionById(name: number): Promise<CommonResponse> {
    try {
      // Find the question in tabQuestion table
      const question = await this.qBankRepoLatest.findOne({
        where: { name }
      });

      if (!question) {
        return new CommonResponse(false, 404, 'Question not found');
      }

      // Convert entity to DTO
      const response = {
        name: question.name,
        classId: question.class,
        className: question.class,
        subject: question.subject,
        subjectName: question.subject,
        chapter: question.chapter,
        chapterName: question.chapter,
        topic: question.topic,
        topicName: question.topic,
        qno: question.q_no,
        questionType: question.cognitive,
        difficultyLevel: question.difficulty,
        marks: question.marks,
        question: question.question ? decodeURIComponent(question.question) : '',
        questionEn: question.question ? decodeURIComponent(question.question) : '',
        questionTe: question.question_te ? decodeURIComponent(question.question_te) : '',
        questionUr: question.question_ur ? decodeURIComponent(question.question_ur) : '',
        language: question.language === 'te' ? 2 : question.language === 'ur' ? 3 : 1,
        userName: question.owner,
        approvedBy: question.modified_by,
        timeStamp: question.creation?.toISOString() || '',
        etimeStamp: question.modified?.toISOString() || '',
        eStatus: question.docstatus,
        isActive: question.status === 'Active',
        answerEn: question.answer_en ? decodeURIComponent(question.answer_en) : '',
        answerTe: question.answer_te ? decodeURIComponent(question.answer_te) : '',
        answerUr: question.answer_ur ? decodeURIComponent(question.answer_ur) : ''
      };

      return new CommonResponse(true, 200, 'Question retrieved successfully', response);
    } catch (error) {
      return new CommonResponse(false, 500, 'Error retrieving question', error.message);
    }
  }

  async getAllQuestionBankData(req: QuestionBankViewReq): Promise<QuestionBankResponse> {
    const savedData = await this.qBankRepo.getAllQuestionBankData(req);
    return new QuestionBankResponse(true, 123, 'All Questions retrieved Successfully', savedData);
  }

  async GetSingleQuestionBankData(req: QuestionBankViewReq): Promise<LatestNewQuestionsResponse> {
    try {
      // console.log('----------------', req)
      const rawData = await this.qBankRepo.GetSingleQuestionBankData(req);

      // Transform raw data to LatestNewQuestionModel
      const transformedData: LatestNewQuestionModel[] = rawData.map(item => {
        return new LatestNewQuestionModel({
          id: item.id,
          qno: item.qno,
          qno_en: item.qno_en,
          qno_te: item.qno_te,
          qno_ur: item.qno_ur,
          marks: item.marks,
          question_en_id: item.question_en_id,
          question_te_id: item.question_te_id,
          question_ur_id: item.question_ur_id,
          question_en: item.question_en,
          question_te: item.question_te,
          question_ur: item.question_ur,
          className: item.className,
          subject_en: item.subject_en,
          subject_te: item.subject_te,
          subject_ur: item.subject_ur,
          chapter_en: item.chapter_en,
          chapter_te: item.chapter_te,
          chapter_ur: item.chapter_ur,
          language: item.language,
          isActive: item.isActive === 1,
          topic: item.topic,
          difficulty: item.difficulty,
          complexity: item.complexity,
          answer_en: item.answer_en,
          answer_te: item.answer_te,
          answer_ur: item.answer_ur,
          createdAt: new Date(),
          updatedAt: new Date()
        });
      });

      console.log("dataaaaaaaa--------", transformedData)
      return new LatestNewQuestionsResponse(
        true,
        200,
        'All questions retrieved successfully',
        transformedData
      );

    } catch (error) {
      console.error('Error in service GetSingleQuestionBankData:', error);
      return new LatestNewQuestionsResponse(
        false,
        500,
        'Internal server error',
        []
      );
    }
  }

  async getAllLatestQuestionBankData(req: LatestQuestionBankViewReq): Promise<LatestQuestionBankResponse> {
    const savedData = await this.qBankRepoLatest.getAllQuestionBankData(req);
    return new LatestQuestionBankResponse(true, 123, 'All Questions retrieved Successfully', savedData);
  }

  async activateOrDeactivateQuestion(req: QNPIdReq): Promise<CommonResponse> {
    const find = await this.qBankRepo.findOne({ where: { id: req.qnpId } });
    if (find.isActive || !find.isActive) {
      await this.qBankRepo.update({ id: req.qnpId }, { isActive: !find.isActive });
      return new CommonResponse(true, 125478, `${find.isActive ? "Deactivated Successfully" : !find.isActive ? "Record Activated Successfully" : "Failed"}`);
    } else {
      throw new ErrorResponse(123458, "Status Not Found");
    }
  }

  async activateOrDeactivateLatestQuestion(req: QNPIdReq): Promise<CommonResponse> {
    const find = await this.qBankRepoLatest.findOne({ where: { name: req.qnpId } });
    if (find) {
      await this.qBankRepoLatest.update({ name: req.qnpId }, { status: find.status === 'Active' ? 'Inactive' : 'Active' });
      return new CommonResponse(true, 125478, `${find.status === 'Active' ? "Deactivated Successfully" : "Activated Successfully"}`);
    } else {
      throw new ErrorResponse(123458, "Record Not Found");
    }
  }

  async getQuestionsCountSummery(req: ClassRequestModel): Promise<CommonResponse> {
    const data: QuestionsCountModel = await this.qBankRepo.getQuestionsCountSummery(req);
    return new CommonResponse(true, 125478, 'summery count retrieved successfully', data);
  }

  async getQuestionSubjectPivot(req: ClassRequestModel): Promise<CommonResponse> {
    const data: SubjectPivotCount[] = await this.qBankRepo.getQuestionSubjectPivot(req);
    return new CommonResponse(true, 125478, 'summery count retrieved successfully', data);
  }

  async getAllCollegeCodesAndSymbols(): Promise<CommonResponse> {
    const savedData = await this.CollegeCodesRepo.find();
    return new CommonResponse(true, 2244, 'College Codes And Symbols Retrived Successfully', savedData)
  }

  async getAllQuestionsCountsBySubject(req: SubjectClassReqModel): Promise<CommonResponse> {
    const savedData = await this.qBankRepo.getAllQuestionsCountsBySubject(req);
    return new CommonResponse(true, 125, 'All Questions retrieved Successfully', savedData);
  }

  getLanguageColumn(language: string) {
    switch (language.toUpperCase()) {
      case 'ENGLISH':
        return 'question';
      case 'TELUGU':
        return 'question_te';
      case 'URDU':
        return 'question_ur';
      default:
        throw new ErrorResponse(400, `Unsupported language: ${language}`);
    }

  }


  async migrateTabQuestionsToCreateQuestions(req: MigrateReqModal): Promise<CommonResponse> {
    const tabQnosData = await this.qBankRepoLatest.getRequestedMigrationQuestions(req);
    const classData = await this.classMasterRepo.findOne({ where: { class: req.className } });
    const baseLanguageEntity = await this.languageMasterRepo.findOne({ where: { language: req.baseLanguage } });
    if (!classData) {
      throw new ErrorResponse(400, `Class '${req.className}' not found`);
    }
    if (!baseLanguageEntity) {
      throw new ErrorResponse(400, `Base Language '${req.baseLanguage}' not found`);
    }
    if (req.requestedLanguages.slice(-1)[0].toUpperCase() !== req.baseLanguage) {
      throw new ErrorResponse(400, `Base language ${baseLanguageEntity.language} should have to be in last of requested languages`);
    }
    for (const tabQno of tabQnosData) {
      const baseSubjectEntity = await this.subjectMasterRepo.findOne({ where: { subject: tabQno.subject, class: classData.id, language: baseLanguageEntity.id } });
      if (!baseSubjectEntity) {
        throw new ErrorResponse(400, `Subject '${tabQno.subject}' not found for class '${req.className}'`);
      }

      const baseChapterEntity = await this.chapterMasterRepo.findOne({ where: { chapter: tabQno.chapter, subject: baseSubjectEntity.id } });
      if (!baseChapterEntity) {
        throw new ErrorResponse(400, `Chapter '${tabQno.chapter}' not found for subject '${tabQno.subject}' in class '${req.className}'`);
      }

      for (const lang of req.requestedLanguages) {
        const languageEntity = await this.languageMasterRepo.findOne({ where: { language: lang } });
        if (!languageEntity) {
          throw new ErrorResponse(400, `Language '${lang}' not found for subject '${tabQno.subject}' in class '${req.className}'`);
        }
        const subjectEntity = await this.subjectMasterRepo.findOne({ where: { subject: tabQno.subject, class: classData.id, language: languageEntity.id, subjectParentId: baseSubjectEntity.id } });
        if (!subjectEntity) {
          console.log(`Subject '${tabQno.subject}' not found for language '${lang}' in class '${req.className}', skipping...`);

          continue; // Skip if subject not found for this language
        }
        const chapterEntity = await this.chapterMasterRepo.findOne({ where: { subject: subjectEntity.id, chapterParentId: baseChapterEntity.id } });
        if (!chapterEntity) {
          console.log(`Chapter '${tabQno.chapter}' not found for subject '${tabQno.subject}' in language '${lang}' for class '${req.className}', skipping...`);
          continue; // Skip if chapter not found for this language
        }
        const topicEntity = await this.topicMasterRepo.findOne({ where: { topic: tabQno.topic, chapter: chapterEntity.id } });
        const topicId = topicEntity ? topicEntity.id : 0; // Default to
        const maxQno = await this.qBankRepo.getMaxQnoBySubject({ classId: classData.id, subject: baseSubjectEntity.id });
        const question = new CreateQuestion();
        question.class = classData.id;
        question.language = languageEntity.id;
        question.subject = subjectEntity.id;
        question.chapter = chapterEntity.id;
        question.topic = topicId;
        question.qno = maxQno + 1;
        question.qtype = 0;
        question.complexity = 0;
        question.marks = tabQno.marks ? Number(tabQno.marks) : 0;
        question.question = req.requestedLanguages.length === 1 ? tabQno.question : tabQno[this.getLanguageColumn(lang)];
        question.username = tabQno.owner;
        question.approvedby = tabQno.modified_by;
        const timestamp = Math.floor(Date.now() / 1000);
        question.timestamp = `${timestamp}`;
        question.etimestamp = `${timestamp}`;
        question.estatus = tabQno.docstatus;
        question.isActive = tabQno.status === 'Active';
        await this.qBankRepo.save(question);
      }

    }


    return new CommonResponse(true, 125, 'Tab Questions Migration is done successfully');
  }
}

